export const AUTH_CAPTCHA_LOGIN_HINT = "Complete the security check below before signing in.";

export const AUTH_CAPTCHA_SIGNUP_HINT =
  "Complete the security check below before creating your account.";

export const AUTH_CAPTCHA_RESET_HINT =
  "Complete the security check below before requesting a reset link.";

export const AUTH_CAPTCHA_CONTACT_HINT =
  "Complete the security check below before sending your message.";

/** Shown inline when the user submits before completing Turnstile. */
export const AUTH_CAPTCHA_REQUIRED_ERROR =
  "CAPTCHA verification required. Please complete the security check below.";

/** Shown when a previously valid Turnstile token expired before submit. */
export const AUTH_CAPTCHA_EXPIRED_ERROR =
  "Security check expired. Please complete the verification below again.";

/** Shared hint styling — visible but secondary to primary form labels. */
export const AUTH_CAPTCHA_HINT_CLASS = "text-sm text-muted-foreground text-center font-medium";
